
import { Component, Vue, Ref, Watch } from 'vue-property-decorator';
// import htmlSanitize from 'spa-ionata-admin/lib/services/htmlSanitize';
// import { isCurrentRoute } from 'spa-ionata-admin/lib/services/compareRoutes';
import vuetify from '../plugins/vuetify';
import i18n from '../i18n';
import { extNavModule } from '../store';
import LangDropdown from './LangDropdown.vue';

const _weakMap = new WeakMap();

const _supportsResizeObserver = 'ResizeObserver' in window;

@Component({ components: {} })
export default class extends Vue {
  @Ref() readonly div!: HTMLElement;

  _langSel: Vue | undefined;

  isMounted = false;

  _cleanup: (() => void) | undefined;

  get headerHtml() {
    if (!extNavModule.header) {
      return undefined;
    }
    // return htmlSanitize(extNavModule.header;
    return extNavModule.header;
  }

  // addHomeLink(parent: Element) {
  //   const homeNav = document.createElement('li');
  //   homeNav.className = 'nav-item';
  //   const homeLink = document.createElement('a');
  //   homeLink.className = 'nav-link';
  //   homeLink.href = '/';
  //   homeLink.textContent = 'DIRECTORY';
  //   homeLink.addEventListener('click', (event: Event) => {
  //     event.preventDefault();
  //     const exact = true;
  //     if (!isCurrentRoute(this.$router, '/', undefined, exact)) {
  //       this.$router.push('/');
  //     }
  //   });
  //   homeNav.appendChild(homeLink);
  //   parent.insertBefore(homeNav, parent.firstElementChild);
  // }

  addResizeObserver() {
    if (this._cleanup) {
      return;
    }
    if (_supportsResizeObserver) {
      const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const { contentBoxSize, contentRect } = entry;
          if (contentBoxSize) {
            const typed = contentBoxSize as
              | ResizeObserverSize
              | ResizeObserverSize[];
            // Firefox implements `contentBoxSize` as a single content rect, rather than an array
            const size = Array.isArray(typed)
              ? (typed[0] as ResizeObserverSize)
              : typed;
            this.updateCssVar(size.blockSize);
          } else {
            this.updateCssVar(contentRect.height);
          }
        });
      });
      resizeObserver.observe(this.div);
      this._cleanup = () => {
        resizeObserver.disconnect();
      };
    } else {
      let timeout = 0;
      const ms = 300;
      const debouncedUpdater = () => {
        clearTimeout(timeout || undefined);
        timeout = setTimeout(() => {
          this.enqueueCssVarUpdate();
        }, ms);
      };
      window.addEventListener('resize', debouncedUpdater);
      this._cleanup = () => {
        window.removeEventListener('resize', debouncedUpdater);
      };
    }
  }

  async enqueueCssVarUpdate() {
    await this.$nextTick();
    if (!this.isMounted || !this.div) {
      return;
    }
    try {
      const style = window.getComputedStyle(this.div);
      const { height } = style;
      const num = parseFloat(height.replace('px', ''));
      this.updateCssVar(num);
    } catch (err) {
      // ignore
    }
  }

  updateCssVar(height: number) {
    document.documentElement.style.setProperty(
      '--ext-header-height',
      `${height}px`,
    );
  }

  mounted() {
    this.isMounted = true;
    extNavModule.fetchIfNeeded();
    if (this.headerHtml !== undefined) {
      this.onNavHtmlChanged();
    }
    this.addResizeObserver();
  }

  beforeDestroy() {
    this.isMounted = false;
    if (this._langSel) {
      this._langSel.$destroy();
      this._langSel = undefined;
    }
    if (this._cleanup) {
      this._cleanup();
      this._cleanup = undefined;
    }
  }

  @Watch('headerHtml')
  async onNavHtmlChanged() {
    await this.$nextTick();
    const header = this.div.querySelector('header');
    // eslint-disable-next-line
    const searchButton = header?.querySelector(
      '.l-site-header__icon-link--search',
    );
    // Google Translate script
    let googleTranslateScript = document.createElement('script');
    googleTranslateScript.setAttribute(
      'src',
      'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit',
    );
    googleTranslateScript.setAttribute('type', 'text/javascript');
    document.head.appendChild(googleTranslateScript);
    // eslint-disable-next-line
    (window as any).googleTranslateElementInit = () => {
      // eslint-disable-next-line
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'zh-CN,zh-TW,fr,de,it,id,ja,ko,vi,ta',
          // eslint-disable-next-line
          layout: (window as any).google.translate.TranslateElement.InlineLayout
            .SIMPLE,
          autoDisplay: false,
        },
        'google_translate_element',
      );
    };
    if (header && searchButton) {
      // Create Google Translation button
      const googleTranslateElement = document.createElement('div');
      googleTranslateElement.setAttribute('id', 'google_translate_element');
      header.insertBefore(googleTranslateElement, searchButton);

      // Create our translation button
      const el = document.createElement('div');
      header.insertBefore(el, searchButton);
      if (this._langSel) {
        this._langSel.$destroy();
      }
      this._langSel = new Vue({
        el,
        i18n,
        vuetify,
        render: h => h(LangDropdown),
      });
      // if (!_weakMap.has(parent)) {
      //   this.addHomeLink(parent);
      //   _weakMap.set(parent, true);
      // }
    }
    const dropdowns = this.div.querySelectorAll('[data-mobile-submenu]');
    if (dropdowns?.length) {
      Array.from(dropdowns).forEach(el => {
        if (_weakMap.has(el)) {
          return;
        }
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const handler = bootstrapToggle(el as HTMLElement);
        if (handler) {
          el.addEventListener('click', handler);
          // el.addEventListener('keydown', handler);
          _weakMap.set(el, true);
        }
      });
    }
    const toggler = this.div.querySelector('[data-navigation-trigger]');
    if (toggler && !_weakMap.has(toggler)) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      const handler = bootstrapNavigation(toggler as HTMLElement);
      if (handler) {
        toggler.addEventListener('click', handler);
        _weakMap.set(toggler, true);
      }
    }
    if (!_supportsResizeObserver) {
      this.enqueueCssVarUpdate();
    }
  }
}

function bootstrapToggle(el: HTMLElement): ((event: Event) => void) | null {
  const toggler = el.querySelector('[data-mobile-submenu-opener]');
  const target = el.querySelector('[data-mobile-submenu-list]');
  if (!toggler || !target) {
    return null;
  }
  const onHide = () => {
    target.classList.remove('show');
    document.removeEventListener('click', onHide);
    toggler.setAttribute('aria-expanded', 'false');
  };
  const handleKeypress = (event: KeyboardEvent) => {
    if (event.isComposing || event.keyCode === 229) {
      return;
    }
    const isVisible = target.classList.contains('show');
    const { key } = event;
    const isArrowDown = key === 'ArrowDown';
    const isArrowUp = key === 'ArrowUp';
    if (!isVisible) {
      if (isArrowUp || isArrowDown) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        handleClick(event);
      }
      return;
    }
    const isTab = key === 'Tab';
    if (isTab) {
      requestAnimationFrame(() => {
        const focused = el.querySelector('*:focus');
        if (!focused) {
          onHide();
        }
      });
    }
    if (isArrowDown || isArrowUp) {
      event.preventDefault();
      event.stopPropagation();
      const focused = target.querySelector('.dropdown-item:focus');
      if (focused) {
        const items = target.querySelectorAll('.dropdown-item');
        const incValue = isArrowDown ? 1 : -1;
        for (let n = 0; n < items.length; n += 1) {
          if (items[n] === focused) {
            const next = items[n + incValue] as HTMLElement;
            if (next) {
              next.focus();
            }
            break;
          }
        }
      } else {
        const first = target.querySelector('.dropdown-item') as HTMLElement;
        if (first) {
          first.focus();
        }
      }
    }
  };
  const handleClick = (event: Event) => {
    const isVisible = target.classList.contains('show');
    if (isVisible) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    target.classList.add('show');
    document.addEventListener('click', onHide);
    toggler.setAttribute('aria-expanded', 'true');
  };
  return event => {
    const { type } = event;
    if (type === 'keydown') {
      handleKeypress(event as KeyboardEvent);
    } else if (type === 'click') {
      handleClick(event);
    }
  };
}

function bootstrapNavigation(el: HTMLElement): ((event: Event) => void) | null {
  const toggler = el;
  const targetSel = '[data-navigation-target]';
  const target = document.querySelector(targetSel) as HTMLElement;
  if (!target) {
    return null;
  }
  return event => {
    event.preventDefault();
    event.stopPropagation();
    const isVisible = target.classList.contains('is-active');
    if (isVisible) {
      // Hiding
      toggler.classList.remove('is-active');
      target.classList.remove('is-active');
      document.body.classList.remove('menu-open');
    } else {
      // Showing
      toggler.classList.add('is-active');
      target.classList.add('is-active');
      document.body.classList.add('menu-open');
    }
  };
}
